export class SmallScreenTabs {
    /**
     * @param tabContainer
     * @param selectorTabList
     * @param selectorPanel
     * @param selectorTitle
     * @param selectorContent
     */
    constructor(
        tabContainer,
        {
            selectorTabList = '.ghwp-tab-list',
            selectorPanel = '.ghwp-tab-panel',
            selectorTitle = '.ghwp-tab-title',
            selectorContent = '.ghwp-tab-content',
        }
    ) {
        this.tabPanels = Array.from(
            tabContainer.querySelectorAll(selectorPanel)
        );
        this.tabList = tabContainer.querySelector(selectorTabList);
        this.selectorTitle = selectorTitle;
        this.selectorContent = selectorContent;

        this.onClick = this.onClick.bind(this);

        this.tabList.setAttribute('aria-hidden', 'true');
        // Add semantics, init accordion panel
        this.tabPanels.forEach(this.initAccordionPanel, this);
        // Click events
        this.tabPanels.forEach(this.setClickEventHandlers, this);
    }

    /**
     * Init tab panels as accordion elements
     *
     * @param tabPanel
     */
    initAccordionPanel(tabPanel) {
        let title = tabPanel.querySelector(this.selectorTitle);
        let content = tabPanel.querySelector(this.selectorContent);

        tabPanel.removeAttribute('hidden');
        title.innerHTML = `<button aria-expanded="false">${title.innerHTML}</button>`;
        content.setAttribute('aria-hidden', 'true');
    }

    /**
     * Click event handler generator
     *
     * @param tab
     * @return {function(...[*]=)}
     */
    onClick(tab) {
        return e => {
            // Find tab to close
            const openTitle = e.currentTarget.parentNode;
            const openTab = openTitle.parentNode;
            // Find tab to open
            const tabParent = tab.parentNode;
            const closeTab = tabParent.querySelector('.ghwp-is-open');
            this.switchTab(closeTab, openTab);
        };
    }

    /**
     * Set up event handlers on the tab elements
     *
     * @param tab
     */
    setClickEventHandlers(tab) {
        let title = tab.querySelector(this.selectorTitle);
        let toggle = title.querySelector('button');

        toggle.addEventListener('click', this.onClick(tab));
    }

    /**
     * Show a new tab panel, optionally hiding the open one
     *
     * @param oldTab
     * @param newTab
     */
    switchTab(oldTab, newTab) {
        if (oldTab) {
            // Find elements in old tab
            const oldTitle = oldTab.querySelector(this.selectorTitle);
            const oldBtn = oldTitle.querySelector('button');
            const oldContent = oldTab.querySelector(this.selectorContent);
            // Close
            oldBtn.setAttribute('aria-expanded', 'false');
            oldContent.setAttribute('aria-hidden', 'true');
            oldTab.classList.remove('ghwp-is-open');
        }
        // Find elements in new tab
        const newTitle = newTab.querySelector(this.selectorTitle);
        const newBtn = newTitle.querySelector('button');
        const newContent = newTab.querySelector(this.selectorContent);
        // Open
        newBtn.setAttribute('aria-expanded', 'true');
        newContent.setAttribute('aria-hidden', 'false');
        newTab.classList.add('ghwp-is-open');
    }
}
